<template>
  <div>
    <!-- 视频上传 -->
    <video-uploader
      v-if="editable || computedValue.length"
      :min="config.baseQuestionLimitMin || undefined"
      :max="config.baseQuestionLimitMax || undefined"
      ref="videoUploader"
      :tips="computedTips"
      :isShow="editable"
    />
    <!-- 文件展示 -->
    <div v-else>-</div>
  </div>
</template>

<script>
import { getCompMix } from "../../mixins/comp-mix";
import VideoUploader from "@/components/video-uploader/index.vue";
export default {
  mixins: [getCompMix(true)],
  components: {
    VideoUploader,
  },
  computed: {
    computedTips() {
      const tipsArr = [
        "视频格式支持.mp4, .avi, .mov, .wmv, .flv, .mkv，大小不超过200M",
      ];
      if (this.config.baseQuestionLimitMin) {
        tipsArr.push(`至少上传${this.config.baseQuestionLimitMin}个视频`);
      }
      if (this.config.baseQuestionLimitMax) {
        tipsArr.push(`最多上传${this.config.baseQuestionLimitMax}个视频`);
      }
      return tipsArr;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化或回填数据
    init() {
      this.$refs.videoUploader &&
        this.$refs.videoUploader.initFileList(this.computedValue);
    },
    // 提供方法给外部，用于获取上传成功的照片地址
    getData() {
      const videoData = this.$refs.videoUploader.getData();
      console.log("videoData---", videoData);
      return videoData;
    },
  },
};
</script>

<style lang="scss" scoped></style>
